export default {"src":"/_next/static/media/about.bc8eb54b.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};